import { useContext, useEffect, useState } from "react";
import { haveValue } from "../../../helper/common";
import useTranslator from "../../../hooks/useTranslator";
import constants from "../../../Utils/constants";
import LandLordContext from "../../../context/landlord/LandLordContext";
import TenantContext from "../../../context/tenant/TenantContext";
import { useNavigate } from "react-router-dom";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { Button, ChoiceGroup, Field, Modal, Select } from "../../design";

const TenantEmploymentModal = (props) => {
  const navigate = useNavigate();
  const { user, setUser, id, showModal, setShowModal, fetchTenantDocs } = props;
  const { updateCreatedTenant } = useContext(LandLordContext);
  const tenantContext = useContext(TenantContext);
  const { submitProtectedHousingDocuments } = tenantContext;

  const { _t } = useTranslator();
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [formData, setFormData] = useState({
    id: id,
    employment_status: "",
    employment_category: "",
    is_freelancer: false,
    protected_housing: "",
  });
  const [insideModal, setInsideModal] = useState(showModal);
  // const [protectedHousingModal, setProtectedHousingModal] = useState(false);
  const [selectBtn, setSelectBtn] = useState(_t("select") + "...");
  const [selectedDocuments, setSelectedDocuments] = useState([]);

  const handlePropSelect = async (e) => {
    const temp = e.map((val) => ({ label: val?.label, value: val?.value }));
    var placeholder_string = [];

    const selectedValues = temp.map((item) => item.value);

    const tempArr = allDocuments.filter((val) =>
      selectedValues.includes(val?.value)
    );

    tempArr.forEach((val) => {
      placeholder_string.push(
        <span className="placeholder_string">{val?.label}</span>
      );
    });

    if (placeholder_string.length == 0) setSelectBtn(_t("select") + "...");
    else setSelectBtn(placeholder_string);
    setSelectedDocuments(temp);
  };

  useEffect(() => {
    setInsideModal(showModal);
    if (haveValue(user)) {
      setFormData({
        id: id,
        employment_status: user?.employment_status,
        employment_category: user?.employment_category,
        is_freelancer: user?.is_freelancer,
        protected_housing: user?.protected_housing,
      });

      // prefill documents
      const docVals = user?.tenant_extra_field_id?.public_housing_docs || [];
      if (Array.isArray(docVals)) {
        const selectedOptionObjects = allDocuments.filter((opt) =>
          docVals.includes(opt.value)
        );

        setSelectedDocuments(selectedOptionObjects);

        const placeholder_string =
          selectedOptionObjects.length === 0
            ? _t("select") + "..."
            : selectedOptionObjects.map((val) => (
                <span className="placeholder_string" key={val.value}>
                  {val.label}
                </span>
              ));

        setSelectBtn(placeholder_string);
      }
    }
  }, [user]);

  const handleAddProtectedHousingDocuments = async () => {
    try {
      const payload = {
        allDocuments: (selectedDocuments ?? []).map((item) => item?.value),
        llCreated: true,
        user_id: id,
      };
      await submitProtectedHousingDocuments(payload);

      if (fetchTenantDocs) {
        fetchTenantDocs();
      }
      setShowModal(false);
    } catch (err) {
      console.log(err, "error inside handleUploadFile");
    }
  };

  useEffect(() => {
    const tempFunc = () => {
      if (!haveValue(formData?.employment_status)) {
        setButtonDisabled(true);
        return;
      } else if (
        [
          constants.public_servant,
          constants.employed,
          constants.self_employed,
        ].includes(formData?.employment_status ?? "") &&
        !haveValue(formData?.employment_category)
      ) {
        setButtonDisabled(true);
        return;
      }
      setButtonDisabled(false);
    };
    tempFunc();
  }, [formData]);

  const handleInputChangeCategory = (e) => {
    const { value } = e.target;
    if (formData?.employment_status == constants.self_employed) {
      setFormData((prev) => ({
        ...prev,
        is_freelancer: value == "freelancer",
      }));
    }
    // else {
    setFormData((prev) => ({ ...prev, employment_category: value }));
    // }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "protected_housing") {
      setFormData((prev) => ({
        ...prev,
        protected_housing: value === "true",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        employment_status: value,
        employment_category: "",
        is_freelancer: false,
      }));
    }
  };

  const handleSubmitEmployment = () => {
    if (!buttonDisabled) {
      updateCreatedTenant(formData)
        .then((res) => {
          setUser(res.data);
          setShowModal(false);
          setInsideModal(false);
        })
        .catch((err) => {
          console.log("Error inside handleSubmitEmployment", err);
        });
    }
  };

  const allDocuments = [
    {
      value: constants.regulatory_agreement_in_case_of_divorce_separation,
      label: _t(
        "regulatoryAgreementInCaseOfDivorceSeparation",
        "Public Housing Certificates"
      ),
    },
    {
      value: constants.revalued_pension_certificate,
      label: _t("revaluedPensionCertificate", "Public Housing Certificates"),
    },
    {
      value: constants.family_book_marriage_civil_partnership_birth_certificate,
      label: _t(
        "familyBookMarriageCivilPartnershipBirthCertificate",
        "Public Housing Certificates"
      ),
    },
    {
      value: constants.certificate_of_social_security_compliance,
      label: _t(
        "certificateProvingDisabilityStatus",
        "Public Housing Certificates"
      ),
    },
  ];

  const requiresSubcategory = (status) => {
    return [
      constants.public_servant,
      constants.employed,
      constants.self_employed,
    ].includes(status);
  };

  return (
    <>
      {insideModal && (
        <Modal
          open={insideModal}
          onClose={() => {
            setShowModal(false);
            setInsideModal(false);
          }}
          size="wide"
          align="start"
          actionsLayout="end"
          title={_t(
            "beforeContinuingSelectTenantEmployment",
            "On LL side while creating TT and providing docs"
          )}
          actions={
            <Button
              variant="accent"
              size="lg"
              disabled={
                buttonDisabled ||
                !haveValue(formData?.employment_status) ||
                (requiresSubcategory(formData?.employment_status) &&
                  !haveValue(formData?.employment_category)) ||
                (formData.protected_housing === true &&
                  selectedDocuments.length === 0)
              }
              onClick={() => {
                handleSubmitEmployment();
                handleAddProtectedHousingDocuments();
              }}
            >
              {_t("submit")}
            </Button>
          }
        >
          <div className="row">
            <div className="two-items-row">
              <div className="forminput mb-0">
                <Select
                  id="employment_status"
                  label={_t("employmentType")}
                  name="employment_status"
                  onChange={handleInputChange}
                  value={formData?.employment_status}
                  options={[
                    { value: "", label: _t("pleaseSelect") },
                    { value: constants.employed, label: _t("employed") },
                    {
                      value: constants.self_employed,
                      label: _t("selfEmployed"),
                    },
                    { value: constants.student, label: _t("student") },
                    {
                      value: constants.unemployed,
                      label: _t("unemployed"),
                    },
                    { value: constants.retired, label: _t("retired") },
                    {
                      value: constants.public_servant,
                      label: _t("publicServant"),
                    },
                  ]}
                />
              </div>
              <div className="forminput mb-0">
                {requiresSubcategory(formData?.employment_status ?? "") && (
                  <>
                    <Select
                      id="employment_category"
                      label={_t("employmentCategory")}
                      name="employment_category"
                      value={formData?.employment_category}
                      onChange={handleInputChangeCategory}
                      options={(() => {
                        let subcategories = [];
                        if (
                          formData?.employment_status ===
                          constants.public_servant
                        ) {
                          subcategories =
                            constants.public_servant_subcategories;
                        } else if (
                          formData?.employment_status === constants.employed
                        ) {
                          subcategories = constants.employed_subcategories;
                        } else if (
                          formData?.employment_status ===
                          constants.self_employed
                        ) {
                          subcategories = ["ownACompany", "freelancer"];
                        }
                        return [
                          { value: "", label: _t("pleaseSelect") },
                          ...subcategories.map((item) => ({
                            value: item,
                            label: _t(item),
                          })),
                        ];
                      })()}
                    />
                  </>
                )}
              </div>
            </div>
            {formData?.employment_status &&
              (!requiresSubcategory(formData?.employment_status) ||
                formData.employment_category) && (
                <ChoiceGroup
                  name="protected_housing"
                  legend={_t(
                    "areYouApplyingOrDoesYourProfileApplyForAPublicHousingProperty",
                    "Public Housing Popup title"
                  )}
                  value={
                    formData.protected_housing === true
                      ? "true"
                      : formData.protected_housing === false
                        ? "false"
                        : ""
                  }
                  onChange={handleInputChange}
                  options={[
                    { value: "false", label: _t("no") },
                    { value: "true", label: _t("yes") },
                  ]}
                />
              )}
            {formData.protected_housing === true && (
              <Field label={_t("documentType")}>
                <div className="link-property prime-selectmulti multiselect-tenant mb-3">
                  <ReactMultiSelectCheckboxes
                    // key={JSON.stringify(selectedDocuments)}
                    isMulti
                    name="protected_housing_properties"
                    id="protected_housing_properties"
                    options={allDocuments}
                    className="basic-multi-select form-control link_prop_select remove-searchbar"
                    classNamePrefix="select"
                    placeholderButtonLabel={selectBtn}
                    getDropdownButtonLabel={function getDropdownButtonLabe(
                      _ref3
                    ) {
                      return selectBtn;
                    }}
                    selectedOptions={selectedDocuments}
                    onChange={handlePropSelect}
                    defaultValue={selectedDocuments}
                  />
                </div>
              </Field>
            )}
          </div>
        </Modal>
      )}
      {/* <ProtectedHousingPopup
        protectedHousingModal={protectedHousingModal}
        setProtectedHousingModal={setProtectedHousingModal}
        isProtectedHousing={user?.protected_housing ?? false}
        handleInputChange={handleChangePublicHousing}
        handleNextStep={handlePublicHousingSubmit}
      /> */}
    </>
  );
};

export default TenantEmploymentModal;
